import React from 'react';
import { InfoIcon, Tooltip } from '@exxonmobil/react-unity';
import styled from 'styled-components';

const infoButton = (info: String) => {
  return (
    <Tooltip className="em-u-margin-bottom-half" color="light" variant="above">
      <StyledTooltipPassage>
        <InfoIcon />
      </StyledTooltipPassage>
      <StyledTooltipContent>{info}</StyledTooltipContent>
    </Tooltip>
  );
};

const StyledTooltipPassage = styled(Tooltip.Passage)`
  color: #f5f5f5;
  transform: scale(1.25); /* Adjust the scale factor as needed */
  transform-origin: right;
  display: inline-block;
  position: initial;
  align-self: flex-start;
`;

const StyledTooltipContent = styled(Tooltip.Content)`
  left: 5px;
  font-size: 12px;
  text-transform: none;
`;

export default infoButton;
